$(document).ready(function(){
    $('.scrollTo').click(function(e) {
        let jump = $(this).attr('href');
        let new_position = $(jump).offset();
        let scroll = 0;
        $('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
            let new_position = $(jump).offset();
            $('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
        });
        e.preventDefault();
    });

    // Menu open close Script Start Here
    $(document).on("click", ".js-open-menu", function(){
        $('body').toggleClass('open-menu');   
        if ($('body').find('.eq-header__right .nav').is(':visible')){
            $('body').find('.eq-header__right .nav').slideUp(500);
        } else {  
            $('body').find('.eq-header__right .nav').slideDown(500);
        }        
    }); 

    $(document).on("click", function(event){
        let $trigger = $(".js-open-menu, .eq-header");
        if($trigger !== event.target && !$trigger.has(event.target).length){
            $('body').removeClass('open-menu');
        }
    });
    // $('.open_sub_menu').click(function(e) {
    //     e.preventDefault();
    //     if($(this).parent().hasClass('active')){
    //         $(this).parent().removeClass('active');
    //         $(this).next('.eq-header__sub-menu').slideUp(function(){
    //             $(this).css('display', 'none');
    //         });
    //     } else {
    //         $('.nav__link > li').removeClass('active');
    //         $('.eq-header__sub-menu').slideUp(function(){
    //             $(this).css('display', 'none');
    //         });
    //         $(this).parent().addClass('active');
    //         $(this).next('.eq-header__sub-menu').slideDown(function(){
    //             $(this).css('display', 'block');
    //         });
    //     }
    // });
    
    // Menu open close Script End Here

    // js-uspa-slider Start Here
    if($('.js-uspa-slider').length > 0){
        $('.js-uspa-slider').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: false,
            draggable: false,
            pauseOnHover: false,
            swipeToSlide: false,
            speed: 3000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.5,
                        variableWidth: false,
                    }
                }
            ]
        });
    }
    // js-uspa-slider Start Here

    // js-level-up-your-kit-slider Start Here
    if($('.js-level-up-your-kit-slider').length > 0){
        $('.js-level-up-your-kit-slider').slick({
            slidesToShow: 2.5,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            draggable: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1.54,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
    // js-level-up-your-kit-slider End Here

     // JOB VACANCIES slick slider filter js start here*****************
     let relatedPostsSlider = $('.js-new-cpap-supplies-slider').not('.slick-initialized').slick({
        slidesToShow: 4.7,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,            
        prevArrow: '<button type="button" class="prev-arrow"><svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="48" y="48.6799" width="48" height="48" rx="24" transform="rotate(-180 48 48.6799)" fill="#183978"/><path d="M30 24.6799L17.5 24.6799M17.5 24.6799L23.5 30.6799M17.5 24.6799L23.5 18.6799" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="next-arrow"><svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.679932" width="48" height="48" rx="24" fill="#183978"/><path d="M18 24.6799H30.5M30.5 24.6799L24.5 18.6799M30.5 24.6799L24.5 30.6799" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3.5,
                    arrows: true,
                    variableWidth: false
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    arrows: true,
                    variableWidth: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.55,
                    arrows: true,
                    variableWidth: false
                }
            }
        ]
    });
    // Function to set the filter
    function setFilter(filter) {
        relatedPostsSlider.slick('slickUnfilter');
        relatedPostsSlider.slick('slickFilter', function(){
            return $(this).data('category') === filter;
        });
    }
    // Set default filter to London
    setFilter($('.eq-new-cpap-supplies__filter-buttons').find('.js-filter-button').attr("data-filter"));
    $(document).on('click', '.js-filter-button', function(){
        let filter = $(this).data('filter');
        $(this).addClass('active').siblings().removeClass('active');   
        $(this).closest('.shopify-section').find('.eq-new-cpap-supplies__button').find('.eq-btn').addClass("hidden");
        $('.'+filter+"_show_all").removeClass("hidden");       
        setFilter(filter);
    });
    // JOB VACANCIES slick slider filter js end here *****************

     // js-our-happy-sleepers-slider Start Here
     if($('.js-our-happy-sleepers-slider').length > 0){
        $('.js-our-happy-sleepers-slider').slick({
            slidesToShow: 2.31,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            draggable: true,
            dots: true,
            prevArrow: $('.js-our-happy-sleepers-prev'),
            nextArrow: $('.js-our-happy-sleepers-next'),
            appendDots: $('.js-our-happy-sleepers-dots'),
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                        arrows: false
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1.001,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
    // js-our-happy-sleepers-slider End Here
 
    // js-blog-slider start here
    if($('.js-blog-slider').length > 0){ 
        $('.js-blog-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            prevArrow: '<button type="button" class="prev-arrow"><svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="48" y="48.6799" width="48" height="48" rx="24" transform="rotate(-180 48 48.6799)" fill="white"></rect><path d="M30 24.6799L17.5 24.6799M17.5 24.6799L23.5 30.6799M17.5 24.6799L23.5 18.6799" stroke="#D66D78" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
            nextArrow: '<button type="button" class="next-arrow"><svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.679932" width="48" height="48" rx="24" fill="white"></rect><path d="M18 24.6799H30.5M30.5 24.6799L24.5 18.6799M30.5 24.6799L24.5 30.6799" stroke="#D66D78" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                        arrows: false
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1.1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        });
    }
    // js-blog-slider end here

    // Newsletter validation js start here
    $(".eq-newsletter__left .c-form-group .c-form-control:input[type=email], .eq-footer__right .footer-nav-top__right .c-form-group .c-form-control").on('input', function () {
        let inputvalues = $(this).val();
        let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!regex.test(inputvalues)) {
            if (!$(this).next('.email-error').length) {
                $(this).after('<span class="email-error">Invalid your email id</span>');
            }
            $(".quiz-cta__submit").attr("disabled", true);
        } else {
            $(this).next('.email-error').remove();
            $(" .quiz-cta__submit").attr("disabled", false);
        }
    });
    // Newsletter validation js end here

    // product-details slider start here
    if($('.js-product-main-slider').length > 0){
        $('.js-product-main-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            focusOnSelect: false,
            infinite: true,
            speed: 500,
            fade: true,
            draggable: false,
            asNavFor: '.js-product-nav-slider',
            prevArrow: '<button type="button" class="prev-arrow"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="26" y="26" width="26" height="26" rx="13" transform="rotate(-180 26 26)" fill="#EAECF0"/><path d="M17 13L8 13M8 13L12.32 9M8 13L12.32 17" stroke="#183978" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow: '<button type="button" class="next-arrow"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="26" height="26" rx="13" fill="#EAECF0"/><path d="M9 13L18 13M18 13L13.68 17M18 13L13.68 9" stroke="#183978" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        arrows: true
                    }
                }
            ]            
        });
    }
    if($('.js-product-nav-slider').length > 0){
        $('.js-product-nav-slider').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false,
            focusOnSelect: true,
            vertical:true,
            infinite: true, 
            draggable: false,           
            asNavFor: '.js-product-main-slider'            
        });
    }
    $(window).on('load resize', function() {
        if ($('.js-product-nav-slider .slide').length <= 5) {
            console.log('slider');
            $('.cw-product-details .js-product-nav-slider, .cw-product-details-banner .js-product-nav-slider').addClass('no-scroll-slider');
        } else {
            // Optional: Remove the class if the condition is not met
            $('.cw-product-details .js-product-nav-slider, .cw-product-details-banner .js-product-nav-slider').removeClass('no-scroll-slider');
        }
    });
    // product-details slider end here

    // You May Also Like slick slider filter js start here*****************
    let youMayAlsoLike = $('.js-you-may-also-like').not('.slick-initialized').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,            
        prevArrow: $('.js-you-may-also-like-prev'),
        nextArrow: $('.js-you-may-also-like-next'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    arrows: true,
                    variableWidth: false
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    arrows: true,
                    variableWidth: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.55,
                    arrows: true,
                    variableWidth: false
                }
            }
        ]
    });
    // Function to set the filter
    function setFilterAlsoLike(filter) {
        youMayAlsoLike.slick('slickUnfilter');
        youMayAlsoLike.slick('slickFilter', function(){
            return $(this).data('category') === filter;
        });
    }
    // Set default filter to London
    setFilterAlsoLike('CPAPSupplies');
    $(document).on('click', '.js-filter-button', function(){
        let filter = $(this).data('filter');
        $(this).addClass('active').siblings().removeClass('active');          
        setFilterAlsoLike(filter);
    });
    // You May Also Like slick slider filter js end here *****************
    
    if($('.collections-page-ui .ProductList--grid .ProductItem__Info .ProductItem__Title').length > 0){
        $('.collections-page-ui .ProductList--grid .ProductItem__Info .ProductItem__Title').matchHeight({
            byRow: true,
        });       
    }
    
    // Accordian js Start here
    $(function () {
        $('.js-accordian-title').click(function (j) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parents('.cus-accordian').find('.cus-accordian__card').removeClass('active');
                $(this).next().slideUp();
            } else{
                $('.js-accordian-title').removeClass('active');
                $(this).parents('.cus-accordian').find('.cus-accordian__card').removeClass('active');
                $('.js-accordian-title').next().slideUp();
                $(this).addClass('active');
                $(this).parents('.cus-accordian__card').addClass('active');
                $(this).next().slideDown(function(){
                    $(this).css('display', 'block');
                });
            }
            
        });
    }); 
    // Accordian js End here

    // Product QTY js start here
    $(document).on('click','.js-button', function () {
        let val = parseInt($(this).parent().find("input").val());
      
        if ($(this).hasClass("less")) {
          val = val - 1;
        } else if ($(this).hasClass("more")) {
          val = val + 1;
        }      
        if (val < 1) {
          val = 1;
        }      
        $(this).parent().find("input").val(val);
    });      
    // Product QTY js end here

    // js-recently-viewed-slider Start here
    if($('.js-recently-viewed-slider').length > 0){
        $('.js-recently-viewed-slider').slick({
            slidesToShow: 3.5,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            draggable: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1.54,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 
    // js-recently-viewed-slider End here
    
    /* js-collections-header-filter Start here
    if($('.js-collections-header-filter').length > 0){
        $('.js-collections-header-filter').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            draggable: true,
            dots: false,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1.65,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    } 
    // js-collections-header-filter End here */
});